import React, {useEffect, useState} from "react";
import {Autocomplete, Button, Checkbox, TextField, Typography, useMediaQuery,} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import {useTranslation} from "react-i18next";

const icon = <CheckBoxOutlineBlankIcon fontSize="small"/>;
const checkedIcon = <CheckBoxIcon fontSize="small"/>;

export default function MultiTagsJson({
                                          data,
                                          addQuestion,
                                          deleteQuestionsAfterIndex,
                                          goToNextQuestion,
                                          isVisible,
                                          addToUpdateQuestions,
                                          deleteFromQuestionToUpdate,
                                      }) {
    const isMobile = useMediaQuery("(max-width:900px)");
    const [selectedValues, setSelectedValues] = useState([]); // State for selected values
    const [showError, setShowError] = useState(false);
    const {t} = useTranslation();
    const language = localStorage.getItem("i18nextLng");

    // Initialize selectedValues with currentValue
    useEffect(() => {
        if (data?.currentValue && typeof data.currentValue === "object") {
            // Flatten the nested currentValue structure
            const flattenedValues = Object.values(data.currentValue).flat();
            setSelectedValues(flattenedValues);
        }
    }, [data]);

    // Handle changes when tags are selected or deselected
    const onTagsChange = (event, values) => {
        const selectedValuesArray = values.map((option) => option.value); // Extract value properties
        deleteQuestionsAfterIndex(data);
        deleteFromQuestionToUpdate(data);
        setSelectedValues(selectedValuesArray); // Update state
        if (data.required && selectedValuesArray.length === 0) {
            setShowError(true); // Show error if required and no values are selected
        } else {
            setShowError(false);
        }
    };

    // Construct the selected values grouped by category
    const getGroupedSelectedValues = () => {
        return selectedValues.reduce((grouped, value) => {
            const option = data.choices.find((choice) => choice.value === value);
            if (option) {
                const category = option.category; // Use the category as the key
                if (!grouped[category]) {
                    grouped[category] = []; // Initialize the array for the category
                }
                grouped[category].push(value); // Add the value to the category
            }
            return grouped;
        }, {});
    };

    // Handle the "Next" button click
    const handleNextClick = () => {
        if (data && selectedValues && selectedValues !== data.currentValue) {
            const groupedValues = getGroupedSelectedValues();
            console.log("groupedValues", groupedValues);
            addToUpdateQuestions(data, groupedValues); // Pass grouped values
        }

        if (data?.question_object) {
            // If the question_object type is "multiTags", update its choices
            if (
                data?.question_object?.type === "multiTags" &&
                data?.question_object?.key === "service_model_C"
            ) {
                const selectedChoices = data.question_object.choices.filter((choice) =>
                    selectedValues.includes(choice.value)
                );
                data.question_object.choices = selectedChoices; // Filter choices based on selected values
            }
            addQuestion(data.question_object); // Add the modified question_object
        } else {
            // Otherwise, move to the next question
            goToNextQuestion();
        }
    };

    function handleSkipClick() {
        if (data?.associated_step_id === "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b") {
            if (data?.question_object) {

                addQuestion(data?.question_object);
            } else {
                // Otherwise, move to the next question
                goToNextQuestion(null, true);
            }
        } else {
            goToNextQuestion(null, true);
        }
    }

    return (
        <div style={{padding: "20px"}}>
            {/* Question */}
            <Typography variant="subtitle1" sx={{mb: 2}}>
                {language === "fr" ? data?.question_fr : data.question}
            </Typography>

            {/* Autocomplete */}
            <Autocomplete
                value={selectedValues
                    .map((value) => data.choices.find((option) => option.value === value))
                    .filter(Boolean)} // Map selected values to their corresponding objects
                multiple
                options={data.choices} // Options provided by the parent component
                disableCloseOnSelect // Allow multiple selections without closing the dropdown
                groupBy={(option) => t(option.category)} // Group options by category
                getOptionLabel={(option) => t(option.value)} // Display value as label
                onChange={onTagsChange} // Handle selection changes
                renderOption={(props, option, {selected}) => (
                    <li {...props}>
                        <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{marginRight: 8}}
                            checked={selected}
                        />
                        {t(option.value)} {/* Translate the option value */}
                    </li>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}

                        placeholder={language === "fr" ? "Sélectionnez une option" : "Select an option"} // Translated placeholder
                    />
                )}
            />

            {/* Error Message */}
            {showError && (
                <span style={{color: "red", marginTop: "8px", display: "block"}}>
                    {t("This field is required")}
                </span>
            )}


            <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                {isVisible(data) && (
                    <Button
                        variant="contained"
                        color="secondary"
                        style={{
                            height: "50px",
                            width: data?.associated_step_id !== "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b" ? "50%" : "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        onClick={handleNextClick}
                        disabled={selectedValues.length === 0} // Disable if required fields are empty
                    >
                        {data?.last_step_question_2 ? t("finish") : t("next")}
                    </Button>
                )}
                {isVisible(data) && (
                    <Button
                        style={{
                            height: "50px",
                            width: "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        color="secondary"
                        variant="contained"
                        onClick={handleSkipClick}
                    >
                        {t("skip")}
                    </Button>
                )}
            </div>
        </div>
    );
}